import { Box } from '@mui/material';

import { AllVisitsFrame } from './AllVisitsFrame';

type AllVisitsPageSkeletonProps = {
    hasMap: boolean;
};

// Route-level fallback that renders without reading anything, so it ships light with the routes.
export const AllVisitsPageSkeleton = ({ hasMap }: AllVisitsPageSkeletonProps) => (
    <AllVisitsFrame map={hasMap ? <Box /> : undefined} />
);
